import { Editor, Element as SlateElement } from 'slate'

import { nodesWithEditableContent } from '../constants/needEmptyLineBeforeTypes'
import { BLOCK_FORMATS, CustomEditor } from '../interface/custom-types'

export const isInAnotherNodeHelper = (editor: CustomEditor) => {
  return !!Editor.above(editor, {
    at: editor.selection?.anchor.path,
    match: (n) =>
      SlateElement.isElement(n) && nodesWithEditableContent.includes(n.type as BLOCK_FORMATS),
  })
}
